"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ImTool_1 = require("./ImTool");
const Utils_1 = require("./Utils");
/**
 * Creates a new instance of ImTool from a <canvas> element.
 * @param video
 */
function fromCanvas(canvas) {
    return Promise.resolve(new ImTool_1.ImTool(canvas));
}
exports.fromCanvas = fromCanvas;
/**
 * Creates a new instance of ImTool from a <video> element. (Must be during playback.)
 * @param video
 */
function fromVideo(video) {
    return Promise.resolve(new ImTool_1.ImTool(video));
}
exports.fromVideo = fromVideo;
/**
 * Creates a new instance of ImTool from a MediaStream. (Must contain at least one video track.)
 * @param stream
 */
function fromMediaStream(stream) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        const video = document.createElement('video');
        video.srcObject = stream;
        video.play();
        video.addEventListener('playing', () => __awaiter(this, void 0, void 0, function* () {
            const tool = yield fromVideo(video);
            // Stop tracks to get rid of browser's streaming notification.
            video.srcObject = null;
            stream.getTracks().forEach(track => track.stop());
            resolve(tool);
        }));
        video.addEventListener('error', e => {
            reject(e);
        });
    }));
}
exports.fromMediaStream = fromMediaStream;
/**
 * Creates a new instance of ImTool from an image URL, Blob, File or an <img> element.
 * The image be from the same origin, or from an origin accessible to the website.
 * @param image The image to be loaded.
 */
function fromImage(image) {
    return __awaiter(this, void 0, void 0, function* () {
        let url;
        if (typeof image === 'string') {
            url = image;
        }
        else if (image instanceof Blob) {
            url = yield Utils_1.fileToDataURL(image);
        }
        else if (image instanceof HTMLImageElement) {
            if (image.complete && image.naturalWidth === 0) {
                return Promise.resolve(new ImTool_1.ImTool(image));
            }
            else {
                url = image.src;
            }
        }
        if (url) {
            const img = yield Utils_1.loadImage(url);
            return new ImTool_1.ImTool(img);
        }
        else {
            throw new Error('Unable to load the image.');
        }
    });
}
exports.fromImage = fromImage;
/**
 * Creates a new instance of ImTool from screen capture.
 */
function fromScreen() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        // @ts-ignore TS's dom.lib.ts doesn't have support for this, yet.
        if (!((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getDisplayMedia)) {
            throw new Error('Screen capture is not supported in this browser.');
        }
        // @ts-ignore TS's dom.lib.ts doesn't have support for this, yet.
        let stream = yield navigator.mediaDevices.getDisplayMedia({
            video: true,
        });
        if (!stream) {
            throw new Error('Unable to start screen capture.');
        }
        return yield fromMediaStream(stream);
    });
}
exports.fromScreen = fromScreen;
/**
 * Creates a new instance of ImTool from webcam capture.
 */
function fromWebcam() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (!((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia)) {
            throw new Error('Webcam capture is not supported in this browser.');
        }
        let stream = yield navigator.mediaDevices.getUserMedia({
            video: true,
        });
        if (!stream) {
            throw new Error('Unable to start webcam capture.');
        }
        return yield fromMediaStream(stream);
    });
}
exports.fromWebcam = fromWebcam;
//# sourceMappingURL=index.js.map